export default __webpack_public_path__ + "static/media/slider.84f5344e.png";